import { Col, Form, FormInstance, Row } from "antd";
import { ColumnsType } from "antd/lib/table";
import moment from "moment";
import TimePicker from "../../../components/atoms/TimePicker";

import CheckBox from "../../../components/atoms/Checkbox";
import Select from "../../../components/atoms/Select";
import { daysArray, numberArray } from "../../../shared/options";
import { theme } from "../../../theme";
import {
  AllDayBreakTime,
  ConfigFormValues,
  DayOffTime,
  MakeDisabledTimeArgs,
  NotWeeklyDayOff,
  ReservationTime,
  RestTime,
  TimeMode,
} from "../Interface";
import DateRangePicker from "../../../components/atoms/DateRangePicker";
import {
  BusinessDayType,
  DayOffDay,
  DayOffWeek,
  ReservationInterval,
  TemporaryBusinessType,
} from "../../../shared/enums";
import PlusTimeTextButton from "../components/PlusTimeTextButton";
import MinusGhostButton from "../components/MinusGhostButton";
import { RepairShopBusiness } from "../../../model/RepairShopBusiness";
import { StyledColumn } from "../styles";
import { RepairShopTemporaryChangedBusiness } from "../../../model/RepairShopTemporaryChangedBusiness";
import {
  checkDuplicatedBreakTime,
  makeDisabledTime,
  stringTimeToMoment,
} from "../utils";
import DeleteButton from "../components/DeleteButton";
import ExplainWrapper from "../../../components/molecures/ExplainWrapper";
import sharedConstants from "../../../shared/constants";
import { ValidationStatus } from "../../Register/components/types";
import { RepairShopBusinessBreakTimes } from "../../../model/RepairShopBusinessBreakTimes";
import { ValidationType } from "../../../components/atoms/Explain/types";

const startTimeWidth = 249;
export const reservationTimeKeys = [
  "weekdayWeekendTimeArray",
  "allDayTime_days_",
  "allDayTime_startTime_",
  "allDayTime_endTime_",
  "weekdayWeekendTimeArray_startTime_",
  "weekdayWeekendTimeArray_endTime_",
];
export const restTimeKeys = [
  "everyDaySameRestTimeArray",
  "notEveryDaySameRestTimeArray_startTime_",
  "notEveryDaySameRestTimeArray_endTime_",
  "alldayBreakTimeArray_days_",
  "alldayBreakTimeArray_startTime_",
  "alldayBreakTimeArray_endTime_",
];
export const maximumTimeKeys = ["maximumTimes", "maximumCounts"];
export const dayOffKeys = [
  "weeklyDayOffs",
  "notWeeklyDayOffs_dayOffWeek_",
  "notWeeklyDayOffs_dayOffDays_",
];
export const holidayTimeKeys = [
  "holidayRestTimes_startTime_",
  "holidayRestTimes_endTime_",
  "holidayEndBusinessTime",
  "holidayStartBusinessTime",
];
export const holidayRestTimeKeys = [
  "holidayRestTimes_endTime_",
  "holidayRestTimes_startTime_",
];
export const temporaryChangedBusinessKeys = [
  "temporaryBusinessChangeRange_",
  "temporaryCloseRanges",
  "temporaryBusinessChangeRange_endBusinessTime_",
  "temporaryBusinessChangeRange_startBusinessTime_",
];
export const getWeekendWeekDayColumns = (
  form: FormInstance
): ColumnsType<ReservationTime> => {
  return [
    {
      dataIndex: "day",
      title: "요일",
      width: 115,
      render: (value, record, index) => {
        return index === 0 ? (
          <div>
            평일
            <br />
            <span style={{ color: theme.colors.gray2 }}>(월 ~ 금)</span>
          </div>
        ) : (
          <div>
            주말
            <br />
            <span style={{ color: theme.colors.gray2 }}>(토 ~ 일)</span>
          </div>
        );
      },
    },
    {
      dataIndex: "startTime",
      title: "시작시간",
      width: startTimeWidth,
      render: (value, record, index) => {
        const getStatus = (): ValidationStatus => {
          if (!record.endTime || !record.startTime)
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };
          if (record.startTime?.isSameOrAfter(record.endTime))
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME,
            };
          return {
            status: undefined,
            explain: undefined,
          };
        };
        return (
          <ExplainWrapper status={getStatus() || undefined}>
            <Form.Item
              noStyle
              name={`weekdayWeekendTimeArray_startTime_${index}`}
              rules={[
                {
                  validator: () => {
                    if (getStatus().status === "error")
                      return Promise.reject(new Error(getStatus().explain));

                    return Promise.resolve();
                  },
                },
              ]}
            />
            <TimePicker
              onOk={(selectedValue) => {
                const newWeekdayWeekendTimeArray = [
                  ...form.getFieldValue("weekdayWeekendTimeArray"),
                ];
                newWeekdayWeekendTimeArray[index].startTime = selectedValue;
                form.setFieldsValue({
                  weekdayWeekendTimeArray: newWeekdayWeekendTimeArray,
                });
              }}
              status={getStatus().status === "error" ? "error" : undefined}
              // disabledTime={() => {
              //   const newWeekdayWeekendTimeArray = [
              //     ...form.getFieldValue("weekdayWeekendTimeArray"),
              //   ];
              //   const { startTime, endTime } =
              //     newWeekdayWeekendTimeArray[index];
              //   return makeDisableStartTime({ startTime, endTime });
              // }}
              value={value}
              // endHour={form
              //   .getFieldValue("weekdayWeekendTimeArray")
              //   [index]?.endTime?.hours()}
              // type={TimeMode.START}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      dataIndex: "endTime",
      title: "종료시간",
      width: startTimeWidth,
      render: (value, record, index) => {
        const getStatus = (): ValidationStatus => {
          if (!record.endTime || !record.startTime)
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };

          if (record.startTime?.isSameOrAfter(record.endTime))
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME,
            };
          return {
            status: undefined,
            explain: undefined,
          };
        };
        return (
          <ExplainWrapper
            status={
              form.getFieldError(`weekdayWeekendTimeArray_endTime_${index}`)
                ?.length > 0
                ? getStatus()
                : undefined
            }
          >
            <Form.Item
              noStyle
              name={`weekdayWeekendTimeArray_endTime_${index}`}
              rules={[
                {
                  validator: () => {
                    if (getStatus().status === "error")
                      return Promise.reject(new Error(getStatus().explain));

                    return Promise.resolve();
                  },
                },
              ]}
            />
            <TimePicker
              onOk={(selectedValue) => {
                const newWeekdayWeekendTimeArray = [
                  ...form.getFieldValue("weekdayWeekendTimeArray"),
                ];
                newWeekdayWeekendTimeArray[index].endTime = selectedValue;
                form.setFieldsValue({
                  weekdayWeekendTimeArray: newWeekdayWeekendTimeArray,
                });
              }}
              status={getStatus().status === "error" ? "error" : undefined}
              // disabledTime={() => {
              //   const newWeekdayWeekendTimeArray = [
              //     ...form.getFieldValue("weekdayWeekendTimeArray"),
              //   ];
              //   const { startTime, endTime } =
              //     newWeekdayWeekendTimeArray[index];
              //   return makeDisableEndTime({ startTime, endTime });
              // }}
              value={value}
              // endHour={form
              //   .getFieldValue("weekdayWeekendTimeArray")
              //   [index]?.startTime?.hours()}
              // type={TimeMode.END}
            />
          </ExplainWrapper>
        );
      },
    },
  ];
};
export const getAlldayColumns = (
  form: FormInstance
): ColumnsType<ReservationTime> => {
  const disabledCheckboxValue = (
    form.getFieldValue("alldayTimeArray") as ReservationTime[]
  ).reduce((pre: string[], cur: ReservationTime) => {
    if (cur.days)
      for (let i = 0; i < cur?.days?.length; i += 1) {
        if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
      }

    return pre;
  }, []);
  return [
    {
      fixed: true,
      dataIndex: "button",
      width: 112,
      title: "추가/삭제",
      render: (value, record, idx) => {
        const disabled = form.getFieldValue("alldayTimeArray")?.length === 1;
        return (
          <StyledColumn>
            <DeleteButton
              onClick={() => {
                const allDayTimeArray = form.getFieldValue("alldayTimeArray");
                form.setFieldsValue({
                  alldayTimeArray: allDayTimeArray.filter(
                    (val: ReservationTime, index: number) => index !== idx
                  ),
                });
              }}
              disabled={disabled}
              stroke={disabled ? theme.colors.gray6 : theme.colors.red3}
              fill={theme.colors.red3}
            />
          </StyledColumn>
        );
      },
    },
    {
      dataIndex: "days",
      title: "요일",
      width: 300,
      render: (value, record, index) => {
        return (
          <ExplainWrapper
            status={{
              status:
                form.getFieldError(`allDayTime_days_${index}`)?.length > 0
                  ? "error"
                  : undefined,
              explain: form.getFieldError(`allDayTime_days_${index}`)[0] || "",
            }}
          >
            <Form.Item
              noStyle
              name={`allDayTime_days_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (value.length === 0)
                      return Promise.reject(
                        new Error(
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                        )
                      );
                    return Promise.resolve();
                  },
                },
              ]}
            />
            <CheckBox
              optionMargin="0px 8px 8px 0px"
              margin="4px 0px 0px 0px"
              options={daysArray}
              value={value}
              disabledValues={disabledCheckboxValue.filter(
                (val) => !value.includes(val)
              )}
              onChange={(e) => {
                const newArray: ReservationTime[] = [
                  ...form.getFieldValue("alldayTimeArray"),
                ];
                newArray[index].days = e;
                form.setFieldsValue({ alldayTimeArray: newArray });
              }}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      dataIndex: "startTime",
      title: "시작시간",
      width: 300,
      render: (value, record, index) => {
        const getStatus = (): ValidationType => {
          if (!record.startTime || !record.endTime)
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };
          if (record.startTime?.isSameOrAfter(record.endTime))
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME,
            };
          return {
            status: undefined,
            explain: undefined,
          };
        };
        return (
          <ExplainWrapper status={getStatus() || undefined}>
            <Form.Item
              noStyle
              name={`allDayTime_startTime_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (getStatus().status === "error")
                      return Promise.reject(getStatus().explain);
                    return Promise.resolve();
                  },
                },
              ]}
            />
            <TimePicker
              onOk={(selectedValue) => {
                const newArray = [...form.getFieldValue("alldayTimeArray")];
                newArray[index].startTime = selectedValue;
                form.setFieldsValue({ alldayTimeArray: newArray });
              }}
              status={getStatus().status === "error" ? "error" : undefined}
              // disabledTime={() => {
              //   const newWeekdayWeekendTimeArray = [
              //     ...form.getFieldValue("alldayTimeArray"),
              //   ];
              //   const { startTime, endTime } =
              //     newWeekdayWeekendTimeArray[index];
              //   return makeDisableStartTime({ startTime, endTime });
              // }}
              value={value}
              // endHour={form
              //   .getFieldValue("alldayTimeArray")
              //   [index]?.endTime?.hours()}
              // type={TimeMode.START}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      dataIndex: "endTime",
      title: "종료시간",
      width: 300,
      render: (value, record, index) => {
        const getStatus = () => {
          if (!record.startTime || !record.endTime)
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };
          if (record.startTime?.isSameOrAfter(record.endTime))
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME,
            };
          return {
            status: undefined,
            explain: undefined,
          };
        };
        return (
          <>
            <Form.Item
              noStyle
              name={`allDayTime_endTime_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (getStatus().status === "error")
                      return Promise.reject(getStatus().explain);
                    return Promise.resolve();
                  },
                },
              ]}
            />
            <TimePicker
              onOk={(selectedValue) => {
                const newArray = [...form.getFieldValue("alldayTimeArray")];
                newArray[index].endTime = selectedValue;
                form.setFieldsValue({ alldayTimeArray: newArray });
              }}
              status={getStatus().status === "error" ? "error" : undefined}
              // disabledTime={() => {
              //   const newWeekdayWeekendTimeArray = [
              //     ...form.getFieldValue("alldayTimeArray"),
              //   ];
              //   const { startTime, endTime } =
              //     newWeekdayWeekendTimeArray[index];
              //   return makeDisableEndTime({ startTime, endTime });
              // }}
              value={value}
              // startHour={form
              //   .getFieldValue("alldayTimeArray")
              //   [index]?.startTime?.hours()}
              // type={TimeMode.END}
            />
          </>
        );
      },
    },
  ];
};

export const getAlldayRestColumns = (
  form: FormInstance,
  makeTime: (days: DayOffDay[]) => MakeDisabledTimeArgs
): ColumnsType<AllDayBreakTime> => {
  const disabledCheckboxValue = form
    .getFieldValue("alldayBreakTimeArray")
    ?.reduce((pre: string[], cur: AllDayBreakTime) => {
      if (cur.days)
        for (let i = 0; i < cur?.days?.length; i += 1) {
          if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
        }

      return pre;
    }, []);
  const disabledAllday = (
    form.getFieldValue("alldayTimeArray") as ReservationTime[]
  )?.reduce((pre: string[], cur: ReservationTime) => {
    if (cur.days)
      for (let i = 0; i < cur?.days?.length; i += 1) {
        if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
      }

    return pre;
  }, []);
  daysArray.forEach((val) => {
    if (!disabledAllday.includes(val.value))
      disabledCheckboxValue.push(val.value);
  });
  const getStatus = (
    array: RepairShopBusinessBreakTimes[],
    index: number,
    timeIndex: number,
    days: DayOffDay[]
  ): ValidationStatus => {
    if (
      (array[timeIndex].endBreakTime && !array[timeIndex].startBreakTime) ||
      (!array[timeIndex].endBreakTime && array[timeIndex].startBreakTime)
    )
      return {
        status: "error",
        explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
      };

    const checkDuplication = checkDuplicatedBreakTime({
      target: {
        startTime: stringTimeToMoment(array[timeIndex].startBreakTime),
        endTime: stringTimeToMoment(array[timeIndex].endBreakTime),
      },
      times: [
        ...array
          ?.filter((val, arrayIdx) => arrayIdx !== timeIndex)
          .map((val) => ({
            startTime: stringTimeToMoment(val.startBreakTime),
            endTime: stringTimeToMoment(val.endBreakTime),
          }))
          .filter((val, index) => index !== timeIndex),
        {
          startTime: makeTime(days)?.fatestStartTime,
          endTime: makeTime(days)?.latestEndTime,
        },
      ],
    });

    if (checkDuplication.status === "error") return checkDuplication;

    return { status: undefined, explain: undefined };
  };
  return [
    {
      fixed: true,
      dataIndex: "button",
      width: 112,
      title: "추가/삭제",
      render: (value, record, idx) => {
        return (
          <StyledColumn>
            <DeleteButton
              onClick={() => {
                const alldayBreakTimeArray = form.getFieldValue(
                  "alldayBreakTimeArray"
                );
                form.setFieldsValue({
                  alldayBreakTimeArray: alldayBreakTimeArray?.filter(
                    (val: ReservationTime, index: number) => index !== idx
                  ),
                });
              }}
              stroke={theme.colors.red3}
              fill={theme.colors.red3}
            />
          </StyledColumn>
        );
      },
    },
    {
      dataIndex: "days",
      title: "요일",
      width: 300,
      render: (value, record, index) => {
        return (
          <ExplainWrapper
            status={{
              status:
                form.getFieldError(`alldayBreakTimeArray_days_${index}`)
                  ?.length > 0
                  ? "error"
                  : undefined,
              explain:
                form.getFieldError(`alldayBreakTimeArray_days_${index}`)[0] ||
                "",
            }}
          >
            <Form.Item
              noStyle
              validateTrigger="onChange"
              name={`alldayBreakTimeArray_days_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (
                      value.filter(
                        (day: DayOffDay) =>
                          !disabledCheckboxValue
                            .filter(
                              (val: DayOffDay) =>
                                !value.includes(val) ||
                                !disabledAllday.includes(val)
                            )
                            .includes(day)
                      )?.length === 0
                    ) {
                      return Promise.reject(
                        new Error(
                          sharedConstants.message.ALERT_MESSAGE.DONT_HAVE_DAY
                        )
                      );
                    }
                    if (value?.length === 0)
                      return Promise.reject(
                        new Error(
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                        )
                      );
                    return Promise.resolve();
                  },
                },
              ]}
            />
            <CheckBox
              optionMargin="0px 8px 8px 0px"
              margin="4px 0px 0px 0px"
              options={daysArray}
              value={value}
              disabledValues={disabledCheckboxValue.filter(
                (val: DayOffDay) =>
                  !value.includes(val) || !disabledAllday.includes(val)
              )}
              onChange={(e) => {
                const newArray: ReservationTime[] = [
                  ...form.getFieldValue("alldayBreakTimeArray"),
                ];
                newArray[index].days = e;
                form.setFieldsValue({ alldayBreakTimeArray: newArray });
              }}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      dataIndex: "breakTimes",
      title: "시작시간",
      width: 300,
      render: (array: RepairShopBusinessBreakTimes[], record, index) => {
        return (
          <Row style={{ width: "100%" }} gutter={[4, 0]}>
            {array?.map((val, arrayIdx) => {
              const status = getStatus(array, index, arrayIdx, record.days);

              return (
                <Col span={24}>
                  <Row wrap={false}>
                    <Col style={{ marginBottom: "8px" }} flex="1 1 100%">
                      <ExplainWrapper
                        status={getStatus(array, index, arrayIdx, record.days)}
                      >
                        <Form.Item
                          noStyle
                          validateTrigger="onChange"
                          rules={[
                            {
                              validator: () => {
                                if (status.status === "error") {
                                  return Promise.reject(
                                    new Error(status.explain)
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                          name={`alldayBreakTimeArray_startTime_${index}_${arrayIdx}`}
                        />
                        <TimePicker
                          onOk={(selectedValue) => {
                            const newArray = [
                              ...form.getFieldValue("alldayBreakTimeArray"),
                            ];
                            newArray[index].breakTimes[
                              arrayIdx
                            ].startBreakTime = selectedValue?.format("HH:mm");
                            form.setFieldsValue({
                              alldayBreakTimeArray: newArray,
                            });
                          }}
                          status={
                            status.status === "error" ? "error" : undefined
                          }
                          value={stringTimeToMoment(val.startBreakTime)}
                          disabledTime={() => {
                            if (makeTime)
                              return makeDisabledTime({
                                fatestEndTime: stringTimeToMoment(
                                  array[arrayIdx].endBreakTime
                                ),
                                fatestStartTime: makeTime(record.days)
                                  ?.fatestStartTime,
                                latestEndTime: makeTime(record.days)
                                  ?.latestEndTime,
                                latestStartTime: stringTimeToMoment(
                                  array[arrayIdx].startBreakTime
                                ),
                                disabledTimes: array.map((val) => ({
                                  startTime: stringTimeToMoment(
                                    val.startBreakTime
                                  ),
                                  endTime: stringTimeToMoment(val.endBreakTime),
                                })),
                                mode: TimeMode.START,
                              });
                            return {};
                          }}
                          endHour={stringTimeToMoment(
                            val.endBreakTime
                          )?.hours()}
                          type={TimeMode.START}
                        />
                      </ExplainWrapper>
                    </Col>
                  </Row>
                </Col>
              );
            })}
            <Col span={24}>
              <PlusTimeTextButton
                arrayLength={form
                  .getFieldValue("alldayBreakTimeArray")
                  ?.reduce((pre: number, next: AllDayBreakTime) => {
                    if (next?.breakTimes) return pre + next.breakTimes?.length;
                    return pre;
                  }, 0)}
                onClick={() => {
                  const newTime: RepairShopBusinessBreakTimes = {
                    startBreakTime: undefined,
                    endBreakTime: undefined,
                  };
                  const allDayBreakTime: AllDayBreakTime[] = [
                    ...form.getFieldValue("alldayBreakTimeArray"),
                  ];
                  allDayBreakTime[index].breakTimes.push(newTime);
                  form.setFieldsValue({
                    alldayBreakTimeArray: allDayBreakTime,
                  });
                }}
              />
            </Col>
          </Row>
        );
      },
    },
    {
      dataIndex: "breakTimes",
      title: "종료시간",
      width: 360,
      render: (array: RepairShopBusinessBreakTimes[], record, index) => {
        return (
          <Row style={{ width: "100%" }} gutter={[4, 0]}>
            {array?.map((val, arrayIdx) => {
              const status = getStatus(array, index, arrayIdx, record.days);
              return (
                <Col style={{ marginBottom: "8px" }} span={24}>
                  <ExplainWrapper status={status}>
                    <Row wrap={false}>
                      <Col flex="1 1 100%">
                        <Form.Item
                          noStyle
                          rules={[
                            {
                              validator: () => {
                                if (status.status === "error") {
                                  return Promise.reject(
                                    new Error(status.explain)
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                          name={`alldayBreakTimeArray_endTime_${index}_${arrayIdx}`}
                        />
                        <TimePicker
                          onOk={(selectedValue) => {
                            const newArray: AllDayBreakTime[] = [
                              ...form.getFieldValue("alldayBreakTimeArray"),
                            ];

                            newArray[index].breakTimes[arrayIdx].endBreakTime =
                              selectedValue?.format("HH:mm");
                            form.setFieldsValue({
                              alldayBreakTimeArray: newArray,
                            });
                          }}
                          status={
                            status.status === "error" ? "error" : undefined
                          }
                          disabledTime={() => {
                            if (makeTime)
                              return makeDisabledTime({
                                fatestEndTime: stringTimeToMoment(
                                  array[arrayIdx].endBreakTime
                                ),
                                fatestStartTime: makeTime(record.days)
                                  ?.fatestStartTime,
                                latestEndTime: makeTime(record.days)
                                  ?.latestEndTime,
                                latestStartTime: stringTimeToMoment(
                                  array[arrayIdx].startBreakTime
                                ),
                                disabledTimes: array.map((val) => ({
                                  startTime: stringTimeToMoment(
                                    val.startBreakTime
                                  ),
                                  endTime: stringTimeToMoment(val.endBreakTime),
                                })),
                                mode: TimeMode.END,
                              });
                            return {};
                          }}
                          value={stringTimeToMoment(val.endBreakTime)}
                          startHour={stringTimeToMoment(
                            val.startBreakTime
                          )?.hours()}
                          type={TimeMode.END}
                        />
                      </Col>
                      <Col
                        flex="0 0 64px"
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <MinusGhostButton
                          onClick={() => {
                            const newAllDayBreakTimes: AllDayBreakTime[] =
                              form.getFieldValue("alldayBreakTimeArray");
                            const newBreakTimes = newAllDayBreakTimes[
                              index
                            ].breakTimes.filter(
                              (val, tIdx) => tIdx !== arrayIdx
                            );
                            newAllDayBreakTimes[index].breakTimes =
                              newBreakTimes;
                            form.setFieldsValue({
                              alldayBreakTimeArray: newAllDayBreakTimes,
                            });
                          }}
                        />
                      </Col>
                    </Row>{" "}
                  </ExplainWrapper>
                </Col>
              );
            })}
          </Row>
        );
      },
    },
  ];
};

export const getNotWeeklyDayOffsColumns = (
  form: FormInstance,
  notWeeklyDayOffs: NotWeeklyDayOff[]
): ColumnsType => [
  {
    dataIndex: "button",
    width: 112,
    align: "left",
    title: "추가/삭제",
    render: (value, record, index: number) => {
      const disabled = notWeeklyDayOffs?.length <= 1;
      return (
        <DeleteButton
          fill={theme.colors.red3}
          disabled={disabled}
          stroke={disabled ? theme.colors.gray6 : theme.colors.red3}
          onClick={() => {
            form.setFieldsValue({
              notWeeklyDayOffs: notWeeklyDayOffs.filter((pre, idx) => {
                return idx !== index;
              }),
            });
          }}
        />
      );
    },
  },
  {
    dataIndex: "dayOffWeek",
    width: 152,
    title: "주",

    render: (value, record, index) => {
      return (
        <Row wrap={false} align="middle" gutter={[10, 0]}>
          <Col flex="1 0 80px">
            <Select
              status={
                form.getFieldError(`notWeeklyDayOffs_dayOffWeek_${index}`)
                  ?.length > 0
                  ? "error"
                  : undefined
              }
              value={value}
              options={numberArray(
                5,
                notWeeklyDayOffs?.map((val: NotWeeklyDayOff) =>
                  Number(val.dayOffWeek)
                )
              )}
              onSelect={(e: number) => {
                const newDatas: NotWeeklyDayOff[] = [
                  ...form.getFieldValue("notWeeklyDayOffs"),
                ];
                newDatas[index].dayOffWeek = e;
                newDatas.sort(
                  (pre, next) =>
                    Number(pre.dayOffWeek) - Number(next.dayOffWeek)
                );
                form.setFieldsValue({ notWeeklyDayOffs: newDatas });
              }}
            />
            <Form.Item
              noStyle
              name={`notWeeklyDayOffs_dayOffWeek_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (!value)
                      return Promise.reject(
                        new Error(
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                        )
                      );
                    return Promise.resolve();
                  },
                },
              ]}
            />
          </Col>
          <Col flex="0 0 100%">
            <span>주차</span>
          </Col>
        </Row>
      );
    },
  },
  {
    dataIndex: "dayOffDays",
    title: "요일",
    render: (value, record, index) => {
      return (
        <ExplainWrapper
          status={{
            status:
              form.getFieldError(`notWeeklyDayOffs_dayOffDays_${index}`)
                ?.length > 0 ||
              form.getFieldError(`notWeeklyDayOffs_dayOffWeek_${index}`)
                ?.length > 0
                ? "error"
                : undefined,

            explain:
              form.getFieldError(`notWeeklyDayOffs_dayOffDays_${index}`)[0] ||
              form.getFieldError(`notWeeklyDayOffs_dayOffWeek_${index}`)[0],
          }}
        >
          <Form.Item
            noStyle
            name={`notWeeklyDayOffs_dayOffDays_${index}`}
            rules={[
              {
                validator: async () => {
                  if (!value)
                    return Promise.reject(
                      new Error(
                        sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                      )
                    );
                  if (value.length === 7)
                    return Promise.reject(
                      new Error("모든 요일을 고를 수는 없습니다.")
                    );
                  return Promise.resolve();
                },
              },
            ]}
          />
          <CheckBox
            optionMargin="0px 8px 8px 0px"
            margin="4px 0px 0px 0px"
            options={daysArray}
            value={value}
            onChange={(e) => {
              const newDatas: NotWeeklyDayOff[] = [
                ...form.getFieldValue("notWeeklyDayOffs"),
              ];
              if (newDatas[index]) {
                newDatas[index].dayOffDays = e;
                form.setFieldsValue({ notWeeklyDayOffs: newDatas });
              }
            }}
          />
        </ExplainWrapper>
      );
    },
  },
];
const restDayTimeWidth = 336;
export const getWeekendWeekRestDayColumns = (
  form: FormInstance,
  makeTime: (e: number) => MakeDisabledTimeArgs
): ColumnsType<RestTime> => {
  const businessType = form.getFieldValue("businessDayTypes");
  let isNoWeekend = false;
  let isNoWeek = false;
  switch (businessType) {
    case BusinessDayType.EVERYDAY: {
      break;
    }

    case BusinessDayType.WEEKDAY_WEEKEND: {
      isNoWeekend =
        !(form.getFieldValue("weekdayWeekendTimeArray") as ReservationTime[])[1]
          ?.startTime ||
        !(form.getFieldValue("weekdayWeekendTimeArray") as ReservationTime[])[1]
          ?.endTime;
      isNoWeek =
        !(form.getFieldValue("weekdayWeekendTimeArray") as ReservationTime[])[0]
          ?.startTime ||
        !(form.getFieldValue("weekdayWeekendTimeArray") as ReservationTime[])[0]
          ?.endTime;
      break;
    }
    case BusinessDayType.DAY: {
      isNoWeek =
        (form.getFieldValue("alldayTimeArray") as ReservationTime[])
          ?.reduce((pre: string[], cur: ReservationTime) => {
            if (cur.days)
              for (let i = 0; i < cur?.days?.length; i += 1) {
                if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
              }

            return pre;
          }, [])
          .filter(
            (val) =>
              val === DayOffDay.MONDAY ||
              val === DayOffDay.THURSDAY ||
              val === DayOffDay.TUESDAY ||
              val === DayOffDay.WEDNESDAY ||
              val === DayOffDay.FRIDAY
          )?.length === 0;

      isNoWeekend =
        (form.getFieldValue("alldayTimeArray") as ReservationTime[])
          ?.reduce((pre: string[], cur: ReservationTime) => {
            if (cur.days)
              for (let i = 0; i < cur?.days?.length; i += 1) {
                if (!pre.includes(cur.days[i])) pre.push(cur.days[i]);
              }

            return pre;
          }, [])
          .filter(
            (val) => val === DayOffDay.SATURDAY || val === DayOffDay.SUNDAY
          )?.length === 0;
      break;
    }
    default: {
      break;
    }
  }

  return [
    {
      dataIndex: "days",
      width: 312,
      title: "요일",
      render: (value, record, index) => {
        return index === 0 ? (
          <div>
            평일
            <br />
            <span style={{ color: theme.colors.gray2 }}>(월 ~ 금)</span>
          </div>
        ) : (
          <div>
            주말
            <br />
            <span style={{ color: theme.colors.gray2 }}>(토 ~ 일)</span>
            <br />
            <ul style={{ paddingInlineStart: "16px", marginBlock: "0px" }}>
              <li style={{ whiteSpace: "pre" }}>
                주말 휴게시간이 없을 경우 시간을 비워주세요.
              </li>
            </ul>
          </div>
        );
      },
    },
    {
      title: "시작시간",
      dataIndex: "times",
      width: restDayTimeWidth,
      render: (value, record, index) => {
        const newNotEveryDaySameRestTimeArray: RestTime[] = form.getFieldValue(
          "notEveryDaySameRestTimeArray"
        );

        const { times } = newNotEveryDaySameRestTimeArray[index];
        const getStatus = (timeIndex: number): ValidationStatus => {
          const isNoBusi = index === 1 ? isNoWeekend : isNoWeek;
          if (isNoBusi) return { status: undefined, explain: undefined };
          if (
            (times[timeIndex].endTime && !times[timeIndex].startTime) ||
            (!times[timeIndex].endTime && times[timeIndex].startTime)
          )
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };

          const checkDuplication = checkDuplicatedBreakTime({
            target: times[timeIndex],
            times: [
              ...times.filter((val, arrayIdx) => arrayIdx !== timeIndex),
              {
                startTime: makeTime(index)?.fatestStartTime,
                endTime: makeTime(index)?.latestEndTime,
              },
            ],
          });
          if (checkDuplication.status === "error") return checkDuplication;
          return { status: undefined, explain: undefined };
        };
        const isNoBusi = index === 1 ? isNoWeekend : isNoWeek;
        return (
          <Row gutter={[0, 8]} style={{ width: "100%" }} align="middle">
            {times.map((time: DayOffTime, timeIndex: number) => (
              <Col key={timeIndex} span={24}>
                <Form.Item
                  noStyle
                  name={`notEveryDaySameRestTimeArray_startTime_${index}_${timeIndex}`}
                  rules={[
                    {
                      validator: () => {
                        if (
                          (times[timeIndex].endTime &&
                            !times[timeIndex].startTime) ||
                          (!times[timeIndex].endTime &&
                            times[timeIndex].startTime)
                        )
                          return Promise.reject(
                            new Error(
                              sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                            )
                          );
                        if (
                          !isNoBusi &&
                          times[timeIndex].startTime &&
                          times[timeIndex].endTime
                        ) {
                          const checkDuplication = checkDuplicatedBreakTime({
                            target: times[timeIndex],
                            times: [
                              ...times.filter(
                                (val, arrayIdx) => arrayIdx !== timeIndex
                              ),
                              {
                                startTime: makeTime(index)?.fatestStartTime,
                                endTime: makeTime(index)?.latestEndTime,
                              },
                            ],
                          });
                          if (checkDuplication.status === "error")
                            return Promise.reject(
                              new Error(checkDuplication.explain)
                            );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                />
                <ExplainWrapper status={getStatus(timeIndex)}>
                  <TimePicker
                    onOk={(selectedTime) => {
                      times[timeIndex].startTime = selectedTime;
                      newNotEveryDaySameRestTimeArray[index].times = times;
                      form.setFieldsValue({
                        notEveryDaySameRestTimeArray:
                          newNotEveryDaySameRestTimeArray,
                      });
                    }}
                    disabled={index === 1 ? isNoWeekend : isNoWeek}
                    status={
                      times[timeIndex].startTime &&
                      times[timeIndex].endTime &&
                      getStatus(timeIndex).status === "error"
                        ? "error"
                        : undefined
                    }
                    disabledTime={() => {
                      if (makeTime)
                        return makeDisabledTime({
                          fatestEndTime: times[timeIndex].endTime,
                          fatestStartTime: makeTime(index)?.fatestStartTime,
                          latestEndTime: makeTime(index)?.latestEndTime,
                          latestStartTime: times[timeIndex].startTime,
                          disabledTimes: times,
                          mode: TimeMode.START,
                        });
                      return {};
                    }}
                    value={time.startTime}
                    type={TimeMode.START}
                    endHour={times[timeIndex].endTime?.hours()}
                  />
                </ExplainWrapper>
              </Col>
            ))}
            <Col span={24}>
              <PlusTimeTextButton
                arrayLength={
                  form.getFieldValue("notEveryDaySameRestTimeArray")[0]?.times
                    ?.length +
                  form.getFieldValue("notEveryDaySameRestTimeArray")[1]?.times
                    ?.length
                }
                onClick={() => {
                  const newTime: DayOffTime = {
                    startTime: undefined,
                    endTime: undefined,
                  };
                  newNotEveryDaySameRestTimeArray[index].times.push(newTime);
                  form.setFieldsValue({
                    notEveryDaySameRestTimeArray: [
                      ...newNotEveryDaySameRestTimeArray,
                    ],
                  });
                }}
              />
            </Col>
          </Row>
        );
      },
    },

    {
      title: "종료시간",
      dataIndex: "times",
      width: restDayTimeWidth + 60,
      render: (value, record, index) => {
        const newNotEveryDaySameRestTimeArray: RestTime[] = form.getFieldValue(
          "notEveryDaySameRestTimeArray"
        );
        const isNoBusi = index === 1 ? isNoWeekend : isNoWeek;
        const { times } = newNotEveryDaySameRestTimeArray[index];
        const getStatus = (timeIndex: number): ValidationStatus => {
          const isNoBusi = index === 1 ? isNoWeekend : isNoWeek;
          if (isNoBusi) return { status: undefined, explain: undefined };
          if (
            (times[timeIndex].endTime && !times[timeIndex].startTime) ||
            (!times[timeIndex].endTime && times[timeIndex].startTime)
          )
            return {
              status: "error",
              explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
            };

          const checkDuplication = checkDuplicatedBreakTime({
            target: times[timeIndex],
            times: [
              ...times.filter((val, arrayIdx) => arrayIdx !== timeIndex),
              {
                startTime: makeTime(index)?.fatestStartTime,
                endTime: makeTime(index)?.latestEndTime,
              },
            ],
          });
          if (checkDuplication.status === "error") return checkDuplication;
          return { status: undefined, explain: undefined };
        };

        return (
          <Row gutter={[0, 8]} style={{ width: "100%" }} align="middle">
            {times.map((time: DayOffTime, timeIndex: number) => {
              return (
                <Col key={timeIndex} span={24}>
                  <Form.Item
                    noStyle
                    name={`notEveryDaySameRestTimeArray_endTime_${index}_${timeIndex}`}
                    rules={[
                      {
                        validator: () => {
                          if (
                            (times[timeIndex].endTime &&
                              !times[timeIndex].startTime) ||
                            (!times[timeIndex].endTime &&
                              times[timeIndex].startTime)
                          )
                            return Promise.reject(
                              new Error(
                                sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                              )
                            );
                          if (
                            times[timeIndex].startTime &&
                            times[timeIndex].endTime &&
                            !isNoBusi
                          ) {
                            const checkDuplication = checkDuplicatedBreakTime({
                              target: times[timeIndex],
                              times: [
                                ...times.filter(
                                  (val, arrayIdx) => arrayIdx !== timeIndex
                                ),
                                {
                                  startTime: makeTime(index)?.fatestStartTime,
                                  endTime: makeTime(index)?.latestEndTime,
                                },
                              ],
                            });
                            if (checkDuplication.status === "error")
                              return Promise.reject(
                                new Error(checkDuplication.explain)
                              );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  <ExplainWrapper status={getStatus(timeIndex)}>
                    <Row
                      justify="start"
                      style={{ height: "32px", width: "100%" }}
                      wrap={false}
                    >
                      <Col flex="1 1 100%">
                        <TimePicker
                          disabled={index === 1 ? isNoWeekend : isNoWeek}
                          onOk={(selectedTime) => {
                            times[timeIndex].endTime = selectedTime;
                            newNotEveryDaySameRestTimeArray[index].times =
                              times;
                            form.setFieldsValue({
                              notEveryDaySameRestTimeArray:
                                newNotEveryDaySameRestTimeArray,
                            });
                          }}
                          status={
                            times[timeIndex].startTime &&
                            times[timeIndex].endTime &&
                            getStatus(timeIndex).status === "error"
                              ? "error"
                              : undefined
                          }
                          disabledTime={() => {
                            if (makeTime)
                              return makeDisabledTime({
                                fatestEndTime: times[timeIndex].endTime,
                                fatestStartTime:
                                  makeTime(index)?.fatestStartTime,
                                latestEndTime: makeTime(index)?.latestEndTime,
                                latestStartTime: times[timeIndex].startTime,
                                disabledTimes: times,
                                mode: TimeMode.END,
                              });
                            return {};
                          }}
                          value={time.endTime}
                          type={TimeMode.END}
                          startHour={times[timeIndex].startTime?.hours()}
                        />
                      </Col>
                      <Col flex="0 0 64px" style={{ textAlign: "center" }}>
                        {newNotEveryDaySameRestTimeArray[index].times?.length >
                          0 && (
                          <MinusGhostButton
                            onClick={() => {
                              const newArray = [
                                ...newNotEveryDaySameRestTimeArray,
                              ];
                              const newRestTime: RestTime = newArray[index];

                              newRestTime.times = times.filter(
                                (v, idx) => idx !== timeIndex
                              );
                              newArray[index] = newRestTime;
                              form.setFieldsValue({
                                notEveryDaySameRestTimeArray: newArray,
                              });
                            }}
                          />
                        )}
                      </Col>
                    </Row>
                  </ExplainWrapper>
                </Col>
              );
            })}
            <Col span={24} style={{ height: "32px" }} />
          </Row>
        );
      },
    },
  ];
};
const timeInputWidth = 250;
export const getTemporaryBusinessChangeTimeColumns = (
  form: FormInstance<ConfigFormValues>,
  temporaryCloseRanges?: moment.Moment[][]
): ColumnsType<RepairShopTemporaryChangedBusiness> => {
  const getStatus = (
    record: RepairShopTemporaryChangedBusiness
  ): ValidationStatus => {
    const { temporaryBusinessStartedAt, temporaryBusinessEndedAt } = record;
    let flag = 0;
    if (temporaryCloseRanges) {
      for (
        let i = 0;
        i <
        (temporaryCloseRanges.filter((val) => val?.length === 2) || [])?.length;
        i += 1
      ) {
        const temporaryCloseRange = temporaryCloseRanges.filter(
          (val) => val?.length === 2
        )[i];
        if (temporaryCloseRange) {
          if (
            (temporaryCloseRange &&
              temporaryBusinessStartedAt &&
              moment(temporaryBusinessStartedAt)?.isBetween(
                temporaryCloseRange[0].hours(0).minutes(0).seconds(0),
                temporaryCloseRange[1].hours(23).minutes(59).seconds(59)
              )) ||
            (temporaryCloseRange &&
              temporaryBusinessEndedAt &&
              moment(temporaryBusinessEndedAt)?.isBetween(
                temporaryCloseRange[0].hours(0).minutes(0).seconds(0),
                temporaryCloseRange[1].hours(23).minutes(59).seconds(59)
              ))
          )
            flag = 1;

          if (
            (temporaryCloseRange &&
              temporaryCloseRange[0] &&
              temporaryBusinessStartedAt &&
              temporaryCloseRange[0]?.isBetween(
                moment(temporaryBusinessStartedAt)
                  .hours(0)
                  .minutes(0)
                  .seconds(0),
                moment(temporaryBusinessEndedAt)
                  .hours(23)
                  .minutes(59)
                  .seconds(59)
              )) ||
            (temporaryCloseRange &&
              temporaryCloseRange[1] &&
              temporaryBusinessStartedAt &&
              temporaryCloseRange[1]?.isBetween(
                moment(temporaryBusinessStartedAt)
                  .hours(0)
                  .minutes(0)
                  .seconds(0),
                moment(temporaryBusinessEndedAt)
                  .hours(23)
                  .minutes(59)
                  .seconds(59)
              ))
          )
            flag = 1;

          if (
            ((record?.startBusinessTime || record?.endBusinessTime) &&
              !record?.temporaryBusinessStartedAt) ||
            ((record?.temporaryBusinessStartedAt || record?.endBusinessTime) &&
              !record?.startBusinessTime) ||
            ((record?.startBusinessTime ||
              record?.temporaryBusinessStartedAt) &&
              !record?.endBusinessTime)
          )
            flag = 2;
          if (
            record?.startBusinessTime &&
            record.endBusinessTime &&
            stringTimeToMoment(record?.startBusinessTime)?.isSameOrAfter(
              stringTimeToMoment(record?.endBusinessTime)
            )
          )
            flag = 3;
        }
      }
    }
    if (flag === 3)
      return {
        status: "error",
        explain: sharedConstants.message.ALERT_MESSAGE.IS_BEFORE_TIME,
      };
    if (flag === 2)
      return {
        status: "error",
        explain: sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED,
      };
    if (flag === 1)
      return {
        status: "error",
        explain: "일시적 영업중단 날짜와 일시적 영업변경날짜가 중복됩니다.",
      };

    if (flag === 0) return { status: undefined, explain: undefined };
    return { status: undefined, explain: undefined };
  };

  return [
    {
      dataIndex: "temporaryBusinessChangeRange",
      title: "날짜",
      width: timeInputWidth,
      render: (value, record: RepairShopTemporaryChangedBusiness, index) => {
        const { temporaryBusinessStartedAt, temporaryBusinessEndedAt } = record;

        return (
          <ExplainWrapper status={getStatus(record)}>
            <Form.Item
              noStyle
              name={`temporaryBusinessChangeRange_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (temporaryCloseRanges)
                      for (
                        let i = 0;
                        i < temporaryCloseRanges?.length;
                        i += 1
                      ) {
                        const temporaryCloseRange = temporaryCloseRanges[i];
                        if (
                          (temporaryCloseRange &&
                            temporaryBusinessStartedAt &&
                            moment(temporaryBusinessStartedAt)?.isBetween(
                              temporaryCloseRange[0],
                              temporaryCloseRange[1]
                            )) ||
                          (temporaryCloseRange &&
                            temporaryBusinessStartedAt &&
                            moment(temporaryBusinessEndedAt)?.isBetween(
                              temporaryCloseRange[0],
                              temporaryCloseRange[1]
                            ))
                        )
                          return {
                            status: "error",
                            explain:
                              "일시적 영업중단 날짜와 일시적 영업변경날짜가 중복됩니다.",
                          };
                        if (
                          (temporaryCloseRange &&
                            temporaryBusinessStartedAt &&
                            temporaryCloseRange[0]?.isBetween(
                              moment(temporaryBusinessStartedAt),
                              moment(temporaryBusinessEndedAt)
                            )) ||
                          (temporaryCloseRange &&
                            temporaryBusinessStartedAt &&
                            temporaryCloseRange[1]?.isBetween(
                              moment(temporaryBusinessStartedAt),
                              moment(temporaryBusinessEndedAt)
                            ))
                        )
                          return {
                            status: "error",
                            explain:
                              "일시적 영업중단 날짜와 일시적 영업변경날짜가 중복됩니다.",
                          };
                      }
                    if (getStatus(record).status === "error")
                      return Promise.reject(
                        new Error(getStatus(record).explain)
                      );

                    return Promise.resolve();
                  },
                },
              ]}
            />
            <DateRangePicker
              value={
                record?.temporaryBusinessStartedAt
                  ? [
                      moment(temporaryBusinessStartedAt),
                      moment(temporaryBusinessEndedAt),
                    ]
                  : undefined
              }
              showNow={false}
              status={getStatus(record).status ? "error" : undefined}
              onChange={(value) => {
                if (value !== null) {
                  const newTemporaryChangedBusinesses: RepairShopTemporaryChangedBusiness[] =
                    form.getFieldValue("temporaryChangeArray");

                  newTemporaryChangedBusinesses[
                    index
                  ].temporaryBusinessStartedAt = value[0]
                    ?.locale("kr")
                    .toISOString();
                  newTemporaryChangedBusinesses[
                    index
                  ].temporaryBusinessEndedAt = value[1]
                    ?.locale("kr")
                    .toISOString();

                  form.setFieldsValue({
                    temporaryChangeArray: newTemporaryChangedBusinesses,
                  });
                } else {
                  const newTemporaryChangedBusinesses: RepairShopTemporaryChangedBusiness[] =
                    form.getFieldValue("temporaryChangeArray");
                  newTemporaryChangedBusinesses[
                    index
                  ].temporaryBusinessStartedAt = undefined;
                  newTemporaryChangedBusinesses[
                    index
                  ].temporaryBusinessEndedAt = undefined;

                  form.setFieldsValue({
                    temporaryChangeArray: newTemporaryChangedBusinesses,
                  });
                }
              }}
              disabledDate={(date) => {
                if (date.year() > 9999 || date.year() < 0) return true;
                if (form.getFieldValue("temporaryCloseRanges")) {
                  for (
                    let i = 0;
                    i <
                    form
                      .getFieldValue("temporaryCloseRanges")
                      ?.filter((val: moment.Moment[]) => val?.length === 2)
                      .length;
                    i += 1
                  ) {
                    const temporaryCloseStart = form
                      .getFieldValue("temporaryCloseRanges")
                      ?.filter((val: moment.Moment[]) => val?.length === 2)[
                      i
                    ][0];
                    const temporaryCloseEnd = form
                      .getFieldValue("temporaryCloseRanges")
                      ?.filter((val: moment.Moment[]) => val?.length === 2)[
                      i
                    ][1];
                    if (
                      (temporaryCloseStart &&
                        date?.isBetween(
                          temporaryCloseStart,
                          temporaryCloseEnd
                        )) ||
                      temporaryCloseEnd?.format("YYYY/MM/DD") ===
                        date?.format("YYYY/MM/DD")
                    ) {
                      return true;
                    }
                  }
                }
                if (moment().isAfter(date)) return true;
                return false;
              }}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      dataIndex: "startBusinessTime",
      title: "시작시간",
      width: timeInputWidth,
      render: (value, record, index) => {
        return (
          <ExplainWrapper status={getStatus(record)} isNotShowText>
            <Form.Item
              noStyle
              name={`temporaryBusinessChangeRange_startBusinessTime_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (getStatus(record).status === "error")
                      return Promise.reject(
                        new Error(getStatus(record).explain)
                      );

                    return Promise.resolve();
                  },
                },
              ]}
            />
            <TimePicker
              value={stringTimeToMoment(value)}
              onOk={(selectedValue) => {
                const newTemporaryChangedBusinesses: RepairShopTemporaryChangedBusiness[] =
                  [...form.getFieldValue("temporaryChangeArray")];
                newTemporaryChangedBusinesses[index].startBusinessTime =
                  selectedValue ? selectedValue.format("HH:mm") : undefined;
                form.setFieldsValue({
                  temporaryChangeArray: newTemporaryChangedBusinesses,
                  repairShopTemporaryBusinesses: newTemporaryChangedBusinesses,
                });
              }}
              status={getStatus(record).status ? "error" : undefined}
              // disabledTime={() => {
              //   const newTemporaryChangedBusinesses: RepairShopTemporaryChangedBusiness[] =
              //     [...form.getFieldValue("temporaryChangeArray")];
              //   const startTime = stringTimeToMoment(
              //     newTemporaryChangedBusinesses[index].startBusinessTime
              //   );
              //   const endTime = stringTimeToMoment(
              //     newTemporaryChangedBusinesses[index].endBusinessTime
              //   );
              //   return makeDisableStartTime({ startTime, endTime });
              // }}
              // type={TimeMode.START}
              // endHour={stringTimeToMoment(record?.endBusinessTime)?.hours()}
            />
          </ExplainWrapper>
        );
      },
    },
    {
      dataIndex: "endBusinessTime",
      title: "종료시간",
      width: timeInputWidth,
      render: (value, record, index) => {
        return (
          <ExplainWrapper status={getStatus(record)} isNotShowText>
            <Form.Item
              noStyle
              name={`temporaryBusinessChangeRange_endBusinessTime_${index}`}
              rules={[
                {
                  validator: async () => {
                    if (getStatus(record).status === "error")
                      return Promise.reject(
                        new Error(
                          sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                        )
                      );

                    return Promise.resolve();
                  },
                },
              ]}
            />
            <TimePicker
              value={stringTimeToMoment(value)}
              onOk={(selectedValue) => {
                const newTemporaryChangedBusinesses: RepairShopTemporaryChangedBusiness[] =
                  [...form.getFieldValue("temporaryChangeArray")];
                newTemporaryChangedBusinesses[index].endBusinessTime =
                  selectedValue ? selectedValue.format("HH:mm") : undefined;

                form.setFieldsValue({
                  temporaryChangeArray: newTemporaryChangedBusinesses,
                  repairShopTemporaryBusinesses: newTemporaryChangedBusinesses,
                });
              }}
              status={getStatus(record).status ? "error" : undefined}
              // disabledTime={() => {
              //   const newTemporaryChangedBusinesses: RepairShopTemporaryChangedBusiness[] =
              //     [...form.getFieldValue("temporaryChangeArray")];
              //   const startTime = stringTimeToMoment(
              //     newTemporaryChangedBusinesses[index].startBusinessTime
              //   );
              //   const endTime = stringTimeToMoment(
              //     newTemporaryChangedBusinesses[index].endBusinessTime
              //   );
              //   return makeDisableEndTime({ startTime, endTime });
              // }}
              // type={TimeMode.END}
              // startHour={stringTimeToMoment(record?.startBusinessTime)?.hours()}
            />
          </ExplainWrapper>
        );
      },
    },
  ];
};
export const temporaryBusinessChangeInitialData = () => {
  return [];
};
export const initialWeek = [
  {
    dayOffWeek: DayOffWeek.EVERY_WEEK,
    dayOffDays: DayOffDay.MONDAY,
  },
  {
    dayOffWeek: DayOffWeek.EVERY_WEEK,
    dayOffDays: DayOffDay.TUESDAY,
  },
  {
    dayOffWeek: DayOffWeek.EVERY_WEEK,
    dayOffDays: DayOffDay.WEDNESDAY,
  },
  {
    dayOffWeek: DayOffWeek.EVERY_WEEK,
    dayOffDays: DayOffDay.THURSDAY,
  },
  {
    dayOffWeek: DayOffWeek.EVERY_WEEK,
    dayOffDays: DayOffDay.FRIDAY,
  },
];
/**
 * 공휴일 기본 설정 제거
 */
export const initialDayOffDays = [
  // DayOffDay.MONDAY,
  // DayOffDay.TUESDAY,
  // DayOffDay.WEDNESDAY,
  // DayOffDay.THURSDAY,
  // DayOffDay.FRIDAY,
];
export const startWeekTimes = [
  "mondayStartBusinessTime",
  "tuesdayStartBusinessTime",
  "wednesdayStartBusinessTime",
  "thursdayStartBusinessTime",
  "fridayStartBusinessTime",
];
export const endWeekTimes = [
  "mondayEndBusinessTime",
  "tuesdayEndBusinessTime",
  "wednesdayEndBusinessTime",
  "thursdayEndBusinessTime",
  "fridayEndBusinessTime",
];
export const startWeekendTime = [
  "saturdayStartBusinessTime",
  "sundayStartBusinessTime",
];
export const endWeekendTime = [
  "saturdayEndBusinessTime",
  "sundayEndBusinessTime",
];
export const holidayTimes = [
  "holidayStartBusinessTime",
  "holidayEndBusinessTime",
];
export const weekRestDays = [
  DayOffDay.MONDAY,
  DayOffDay.TUESDAY,
  DayOffDay.WEDNESDAY,
  DayOffDay.THURSDAY,
  DayOffDay.FRIDAY,
];
export const weekendRestDays = [DayOffDay.SUNDAY, DayOffDay.SATURDAY];
export const dayOffDays: DayOffDay[] = [...weekRestDays, ...weekendRestDays];
export const repairShopBusinessMomentKeys: string[] = [
  ...startWeekTimes,
  ...endWeekTimes,
  ...startWeekendTime,
  ...endWeekendTime,
];
export const initialRepairshopBusiness: RepairShopBusiness = {
  repairShopHolidayWorkdays: undefined,

  businessDayTypes: BusinessDayType.EVERYDAY,

  maximumSimultaneouslyVehicleCount: 1,

  maximumMorningVehicleCount: 1,

  maximumAfternoonVehicleCount: 1,

  reservationInterval: ReservationInterval.SIXTY,

  mondayStartBusinessTime: undefined,

  mondayEndBusinessTime: undefined,

  tuesdayStartBusinessTime: undefined,

  tuesdayEndBusinessTime: undefined,

  wednesdayStartBusinessTime: undefined,

  wednesdayEndBusinessTime: undefined,

  thursdayStartBusinessTime: undefined,

  thursdayEndBusinessTime: undefined,

  fridayStartBusinessTime: undefined,

  fridayEndBusinessTime: undefined,

  saturdayStartBusinessTime: undefined,

  saturdayEndBusinessTime: undefined,

  sundayStartBusinessTime: undefined,

  sundayEndBusinessTime: undefined,

  holidayStartBusinessTime: undefined,

  holidayEndBusinessTime: undefined,

  repairShopDayOffs: [
    { dayOffDay: DayOffDay.FRIDAY, dayOffWeek: DayOffWeek.EVERY_WEEK },
    { dayOffDay: DayOffDay.THURSDAY, dayOffWeek: DayOffWeek.EVERY_WEEK },
    { dayOffDay: DayOffDay.WEDNESDAY, dayOffWeek: DayOffWeek.EVERY_WEEK },
    { dayOffDay: DayOffDay.TUESDAY, dayOffWeek: DayOffWeek.EVERY_WEEK },
    { dayOffDay: DayOffDay.MONDAY, dayOffWeek: DayOffWeek.EVERY_WEEK },
  ],

  repairShopBreakTimes: [
    {
      breakTimeTypes: BusinessDayType.EVERYDAY,
      startBreakTime: undefined,
      endBreakTime: undefined,
    },
  ],
};
export const initialRepairshopTemporaryChangeBusinessTime: RepairShopTemporaryChangedBusiness =
  {
    startBusinessTime: undefined,
    endBusinessTime: undefined,
    temporaryBusinessEndedAt: undefined,
    temporaryBusinessStartedAt: undefined,

    temporaryBusinessType: TemporaryBusinessType.CLOSED,
    temporaryClosedReason: "",
    repairShopBreakTimes: [
      { startBreakTime: undefined, endBreakTime: undefined },
    ],
  };
